// import {
//    faFacebookF,
//    faInstagram,
//    faLinkedinIn,
//    faTwitter,
//    faYoutube,
// } from "@fortawesome/free-brands-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useModal } from "../contexts/ModalContext";


const MenuFull = () => {
  const [serviceOpen, setServiceOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const menuRef = useRef();
  const bgRef = useRef();
  const mainLinksRef = useRef();
  const contactRef = useRef();
  const column3Ref = useRef();
  const closeBtnRef = useRef();
  const coverImageRef = useRef();
  const bgAnimCol2Ref = useRef();

  useEffect(() => {
    const openFullscreenMenu = () => {
      const menu = menuRef.current;
      const bg = bgRef.current;
      const mainLinks = mainLinksRef.current;
      const contacts = contactRef.current;
      const col3 = column3Ref.current;
      const closeBtn = closeBtnRef.current;
      const image = coverImageRef.current;
      const bgAnim = bgAnimCol2Ref.current;

      // Initial States
      menu.style.display = "none";
      menu.style.opacity = "0";
      mainLinks.style.opacity = "0";
      contacts.style.opacity = "0";
      contacts.style.transform =
        "translate3d(-10vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
      contacts.style.transformStyle = "preserve-3d";
      mainLinks.style.transform =
        "translate3d(-10vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
      mainLinks.style.transformStyle = "preserve-3d";
      col3.style.display = "none";
      image.style.transform =
        "translate3d(0px, 0px, 0px) scale3d(1.3, 1.3, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
      image.style.transformStyle = "preserve-3d";
      closeBtn.style.transform =
        "translate3d(-99%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
      closeBtn.style.transformStyle = "preserve-3d";
      bg.style.transform =
        "translate3d(-101%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
      bg.style.transformStyle = "preserve-3d";
      bgAnim.style.display = "block";
      bgAnim.style.transform = "translate3d(0%, 0px, 0px)";
      bgAnim.style.transformStyle = "preserve-3d";

      // Trigger Animation
      menu.style.display = "flex";
      void menu.offsetHeight;
      menu.style.transition = "opacity 0.3s ease";
      menu.style.opacity = "1";

      bg.style.transition = "transform 1s ease-in-out";
      bg.style.transform =
        "translate3d(0%, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";

      setTimeout(() => {
        col3.style.display = "flex";
      }, 600);

      setTimeout(() => {
        mainLinks.style.transition =
          "transform 1s ease-out, opacity 1s ease-out";
        mainLinks.style.transform =
          "translate3d(0vw, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
        mainLinks.style.opacity = "1";
      }, 600);

      setTimeout(() => {
        bgAnim.style.transition = "transform 0.8s ease-in-out";
        bgAnim.style.transform =
          "translate3d(101%, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
      }, 600);

      // setTimeout(() => {
      //   image.style.transition = "transform 1s ease";
      //   image.style.transform =
      //     "translate3d(0px, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
      // }, 600);



      setTimeout(() => {
        // First translate only
        image.style.transition = "transform 0.5s ease";
        image.style.transform =
          "translate3d(-100%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
        image.style.transformStyle = "preserve-3d";
        image.style.willChange = "transform";

        void image.offsetHeight;

        // Then scale after translate finishes
        setTimeout(() => {
          image.style.transition = "transform 1s ease";
          image.style.transform =
            "translate3d(0vw, 0px, 0px) scale3d(1.3, 1.3, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
          image.style.transformStyle = "preserve-3d";

          // Final state (normal scale)
          setTimeout(() => {
            image.style.transition = "transform 2s ease";
            image.style.transform =
              "translate3d(0vw, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
            image.style.transformStyle = "preserve-3d";
          }, 700); // after scale

        }, 100); // after translate
      }, 600);



      setTimeout(() => {
        contacts.style.transition =
          "transform 1s ease-out, opacity 1s ease-out";
        contacts.style.transform =
          "translate3d(0vw, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
        contacts.style.opacity = "1";
      }, 800);

      setTimeout(() => {
        closeBtn.style.transition = "transform 1.4s ease-in-out";
        closeBtn.style.transform =
          "translate3d(0%, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";
      }, 1000);
    };

    const closeFullscreenMenu = () => {
      const menu = menuRef.current;
      const bg = bgRef.current;
      const mainLinks = mainLinksRef.current;
      const contacts = contactRef.current;
      const col3 = column3Ref.current;
      const closeBtn = closeBtnRef.current;
      const image = coverImageRef.current;
      const bgAnim = bgAnimCol2Ref.current;

      closeBtn.style.transition = "transform 0.5s ease-in-out";
      closeBtn.style.transform =
        "translate3d(-99%, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";

      contacts.style.transition = "transform 0.5s ease, opacity 0.5s ease";
      contacts.style.opacity = "0";
      contacts.style.transform =
        "translate3d(-10vw, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";

      mainLinks.style.transition = "transform 0.5s ease, opacity 0.5s ease";
      mainLinks.style.opacity = "0";
      mainLinks.style.transform =
        "translate3d(-10vw, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";

      image.style.transition = "transform 0.5s ease";
      image.style.transform =
        "translate3d(0px, 0px, 0px) scale3d(1.3, 1.3, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";

      col3.style.display = "none";

      bgAnim.style.transition = "transform 0.5s ease";
      bgAnim.style.transform =
        "translate3d(0%, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";

      bg.style.transition = "transform 0.5s ease-in-out";
      bg.style.transform =
        "translate3d(-101%, 0px, 0px) scale3d(1,1,1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)";

      menu.style.transition = "opacity 0.3s ease";
      menu.style.opacity = "0";

      setTimeout(() => {
        menu.style.display = "none";
        bgAnim.style.display = "none";
      }, 500);
    };

    window.openFullscreenMenu = openFullscreenMenu;
    window.closeFullscreenMenu = closeFullscreenMenu;
  }, []);


  const { openQueryModal } = useModal();
  return (
    <>
      <div className="fullscreen-menu mobile-menu" ref={menuRef}>
        <div className="fullscreen-inner">
          <div className="fullscreen-menu-column-1">
            <nav className="fullscreen-main-links" ref={mainLinksRef} aria-label="Mobile navigation">
              <ul className="mobile-link-items">
                <li>
                  <Link to="/" onClick={() => window.closeFullscreenMenu()}>
                    <div className="icon-wraps">
                      <img src="/assets/images/home-icon.webp" alt="Home" loading="lazy" />
                    </div>
                    <div className="text-wraps">Home</div>
                  </Link>
                </li>
                <li>
                  <Link to="/about-us/" onClick={() => window.closeFullscreenMenu()}>
                    <div className="icon-wraps">
                      <img src="/assets/images/about-icon.webp" alt="About" loading="lazy" />
                    </div>
                    <div className="text-wraps">About</div>
                  </Link>
                </li>
                <li className={`only-desktop-links dropdown-child ${serviceOpen ? "active-dropdown" : ""}`} onClick={(e) => {
                  e.stopPropagation();
                  setServiceOpen(prev => !prev);
                }}>
                  <Link>
                    <div className="icon-wraps">
                      <img src="/assets/images/services-icon.webp" alt="Services" loading="lazy" />
                    </div>
                    <div className="text-wraps">Services <i className="fa-solid fa-chevron-down"></i> </div>
                  </Link>

                  <div className="dropdown_menu-wrapper">
                    <ul className="drodown-sub">
                      <li><Link to="/residential-dumpsters-edmonton/" onClick={() => window.closeFullscreenMenu()} >Residential Dumpsters</Link></li>
                      <li><Link to="/construction-dumpsters-edmonton/" onClick={() => window.closeFullscreenMenu()} >Construction Dumpsters</Link></li>
                      <li><Link to="/commercial-dumpster-edmonton/" onClick={() => window.closeFullscreenMenu()} >Commercial Dumpsters</Link></li>
                      {/* <li><Link to="/general-dumpster-edmonton/" nClick={() => window.closeFullscreenMenu()}  >General Dumpsters</Link></li> */}
                      <li><Link to="/other-services/" onClick={() => window.closeFullscreenMenu()}  >Other Services</Link></li>
                    </ul>
                  </div>
                </li>
                <li className="only-desktop-links">
                  <Link to="/pricing/" onClick={() => window.closeFullscreenMenu()}>
                    <div className="icon-wraps">
                      <img src="/assets/images/pricong-icon.webp" alt="International Patients" loading="lazy" />
                    </div>
                    <div className="text-wraps">Pricing</div>
                  </Link>
                </li>


                {/* <li className="only-desktop-links">
                  <Link to="/other-service" onClick={() => window.closeFullscreenMenu()}>
                    <div className="icon-wraps">
                      <img src="/assets/images/services-icon.webp" alt="International Patients" loading="lazy" />
                    </div>
                    <div className="text-wraps"> Other Services</div>
                  </Link>
                </li> */}

                <li className="only-desktop-links">
                  <Link to="/prohibited-items/" onClick={() => window.closeFullscreenMenu()}>
                    <div className="icon-wraps">
                      <img src="/assets/images/prohibited-icon.webp" alt="Blog" loading="lazy" />
                    </div>
                    <div className="text-wraps">Prohibited</div>
                  </Link>
                </li>

                <li className="only-desktop-links">
                  <Link to="/how-to-book-a-bin/" onClick={() => window.closeFullscreenMenu()}>
                    <div className="icon-wraps">
                      <img src="/assets/images/how-it-works.webp" alt="Blog" loading="lazy" />
                    </div>
                    <div className="text-wraps"> How It Works</div>
                  </Link>
                </li>


                <li className="only-desktop-links">
                  <Link to="/blogs/" onClick={() => window.closeFullscreenMenu()}>
                    <div className="icon-wraps">
                      <img src="/assets/images/blogs-icon.webp" alt="Blog" loading="lazy" />
                    </div>
                    <div className="text-wraps">Blog</div>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="fullscreen-menu-column-3" ref={column3Ref}>
            <div className="menu-column-2-contacts" ref={contactRef}>
              <div className="menu-contacts-padding">
                <div className="menu-contacts">
                  <p className="menu-contact-title">Contact</p>
                  <p className="address-text">
                    10006 158 St NW, Edmonton, AB T5P 0L2, Canada
                  </p>
                  <div className="phone-number">
                    <a className="phone-link" href="tel: +1 780 230 1359">
                      <span></span> +1 780 230 1359
                    </a>
                  </div>
                  <nav className="mobile-link" aria-label="Utility navigation">
                    <ul>
                      <li>
                        <Link to="/privacy-policy/" onClick={() => window.closeFullscreenMenu()}>
                          Privacy </Link>
                      </li>
                      <li>
                        <Link to="/contact-us/" onClick={() => window.closeFullscreenMenu()}>
                          Contact</Link>
                      </li>
                      <li>
                        <Link to="/faq/" onClick={() => window.closeFullscreenMenu()}>
                          FAQ’s</Link>
                      </li>
                    </ul>
                  </nav>
                  <nav className="heder-socials" aria-label="Social links">
                    <ul>
                      <li>
                        <Link to="https://www.facebook.com/people/Big-Bin-Rentals/61570009903987/" target="_blank" rel="noreferrer">
                          <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="https://www.instagram.com/bigbinrentals/" target="_blank" rel="noreferrer">
                          <i className="fa-brands fa-instagram"></i>
                        </Link>
                      </li>

                    </ul>
                  </nav>
                </div>
                <Link className="theme-btn" onClick={openQueryModal}>
                  <span className="color-overlay"></span>
                  <span className="btn-txt">Book a Bin</span>
                </Link>
              </div>
            </div>
            <img src="/assets/images/full-bg-inner.webp" className="menu-cover-image" ref={coverImageRef} alt="Background" loading="lazy" />
            <div className="bg-animation-for-column-2" ref={bgAnimCol2Ref}></div>
          </div>
          <div className="close-button" onClick={() =>
            window.closeFullscreenMenu()} ref={closeBtnRef}>
            <div className="close-text-block">
              <p className="close-text">Close</p>
            </div>
            <div className="close-button-bg"></div>
          </div>
          <div className="fullscreen-menu-bg" ref={bgRef}></div>
        </div>
      </div>

    </>
  );
};

export default MenuFull;
